import React from 'react';

import FullPageLoader from './FullPageLoader';

const Loading: React.FC = () => {
  return <FullPageLoader message="Carregando aplicacao..." />;
};

export default Loading;